import { Component, OnInit } from '@angular/core';
import { Globals } from "../../_models/globals";

@Component({
  selector: 'app-rapid-delivery-create',
  templateUrl: './rapid-delivery-create.component.html',
  styleUrls: ['./rapid-delivery-create.component.scss'],
})
export class RapidDeliveryCreateComponent implements OnInit {

  carrierName: string;
  carrierNameError: string;
  token: string;
  tokenError: string;
  client: string;
  clientError: string;

  constructor(public g: Globals) {
  }

  carrierNameBlur() {
    this.carrierNameError = "";
    if (!this.carrierName) {
      this.carrierNameError = 'Please enter carrier name';
    }
  }

  tokenBlur() {
    this.tokenError = "";
    if (!this.token) {
      this.tokenError = 'Please enter token';
    }
  }

  clientBlur() {
    this.clientError = "";
    if (!this.client) {
      this.clientError = 'Please enter client';
    }
  }


  ngOnInit() { }

  verify() {

    this.g.loaderDisplay = "display";
    this.carrierNameError = "";
    this.tokenError = "";
    this.clientError = "";

    if (!this.carrierName) {
      this.carrierNameError = 'Please enter carrier name';
    }
    if (!this.token) {
      this.tokenError = 'Please enter token';
    }
    if (!this.client) {
      this.clientError = 'Please enter client';
    }
    if (this.carrierNameError != "" || this.tokenError != "" || this.clientError != "") {
      this.g.loaderDisplay = "";
      return false;
    }
    // api body

  }

}
